import { Button, Flex, HStack, Heading, Spacer } from "@chakra-ui/react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import EnvSwitcher from "./EnvSwitcher";
import { cognitoLogoutUrl } from "../auth/authConfig";
import { markSignedOut } from "../auth/signedOut";
import { getEnv } from "../hooks/useEnv";

const ITEMS: { to: string; label: string }[] = [
  { to: "/creators", label: "Creators" },
  { to: "/works", label: "Works" },
  { to: "/review-queue", label: "Review queue" },
  { to: "/organizations", label: "Organizations" },
  { to: "/origins", label: "Origins" },
  { to: "/email-templates", label: "Email templates" },
  { to: "/audit", label: "Audit" },
  { to: "/settings", label: "Settings" },
];

export default function TopMenu() {
  const auth = useAuth();
  const loc = useLocation();

  return (
    <Flex
      as="header"
      px={6}
      py={3}
      borderBottomWidth="1px"
      align="center"
      bg="white"
    >
      <Heading
        as={RouterLink}
        to="/"
        size="md"
        mr={8}
        cursor="pointer"
        _hover={{ textDecoration: "underline" }}
      >
        HII Support
      </Heading>
      <HStack spacing={2}>
        {ITEMS.map((item) => (
          <Button
            key={item.to}
            as={RouterLink}
            to={item.to}
            size="sm"
            variant={loc.pathname.startsWith(item.to) ? "solid" : "ghost"}
          >
            {item.label}
          </Button>
        ))}
      </HStack>
      <Spacer />
      <HStack spacing={3}>
        <EnvSwitcher />
        <Button
          size="sm"
          variant="ghost"
          onClick={async () => {
            markSignedOut();
            await auth.removeUser();
            window.location.href = cognitoLogoutUrl(getEnv());
          }}
          isDisabled={!auth.isAuthenticated}
        >
          Sign out
        </Button>
      </HStack>
    </Flex>
  );
}
